<template>
  <div id="leftMain">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "LeftContent",
  mounted() {
    // this.$router.push({ name: "hotlist" });
    this.getid = setInterval(() => {
      let getBox = document.getElementById("leftMain");
      if (getBox) {
        clearInterval(this.getid);
        this.fixEditorHeight(this.contentHeight);
      }
    }, 500);
    // this.$nextTick(() => {
    //   this.fixEditorHeight(this.contentHeight);
    // });
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.fixEditorHeight(val);
      }
    }
  },
  methods: {
    fixEditorHeight(newContentHeight) {
      let toolbar = document.querySelector(".el-header");

      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }
      let editorStatusBarHeight = 1;
      let realHeight =
        newContentHeight - editorToolbarHeight - editorStatusBarHeight;
      let getBox = document.getElementById("leftMain");
      getBox.style.height = realHeight-60 + "px";
      getBox.style.backgroundColor = "#fff";
    }
  }
};
</script>

<style lang="less" scoped>
#leftMain {
  background-color: rgb(255, 255, 255);
  border-right: 1px solid #dee3f8;
  width: 480px;
  position: fixed;
  top: 60px;

}
</style>
